import axios from '../Axios/Default';
import { handleResponse } from '../Utils/Utils';

export const getComBrandAll = (_params, onSuccess, onError) => {
    const response = axios.get('v1/admin/competitor/brand', { params: _params });
    return handleResponse(response, onSuccess, onError);
};

export const getComBrandById = (id, onSuccess, onError) => {
    const response = axios.get(`v1/admin/competitor/brand/${id}`);
    return handleResponse(response, onSuccess, onError);
};

export const createComBrand = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/admin/competitor/brand`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const updateComBrand = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/competitor/brand/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const inActiveComBrand = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/competitor/brand/${id}/inactive`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const softDeleteComBrand = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/competitor/brand/${id}/delete`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const deleteComBrand = (id, onSuccess, onError) => {
    const response = axios.delete(`v1/admin/competitor/brand/${id}`);
    return handleResponse(response, onSuccess, onError);
};